export const HouseCertificate = (props) => {
  const { size = 20, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M12.501 17.503h2.263c.921 0 1.667-.746 1.667-1.667V8.009m-8.468 5.512L6.34 15.142l-.973-.973m-2.87-5.24l6.417-5.502a1.667 1.667 0 012.17 0l2.13 1.827m4.288 3.674l-1.072-.919m0 0V3.331a.834.834 0 00-.834-.834H14.05a.834.834 0 00-.833.834v1.923m3.215 2.755l-3.215-2.755m-10.49 9.593l.554.725.12.9c.067.501.46.895.96.961l.903.121.724.554c.4.306.956.306 1.356 0l.725-.554h0l.901-.12c.5-.067.894-.46.96-.96l.121-.903.554-.724c.306-.4.306-.956 0-1.356l-.554-.725-.12-.9c-.066-.501-.459-.895-.96-.961l-.903-.121-.724-.554a1.117 1.117 0 00-1.356 0l-.724.554h0l-.902.12c-.5.067-.893.46-.96.96l-.12.903-.554.724c-.306.4-.306.955 0 1.356z'
        ></path>
      </svg>
    </span>
  );
};
